/**
 * @generated SignedSource<<0729498586f0ce7fefc6a2196291f816>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type VerifyAndAssignPhoneInput = {
  code: string;
  phoneNumber: string;
};
export type useVerifyAndAssignPhoneCodeProfileMutation$variables = {
  input: VerifyAndAssignPhoneInput;
};
export type useVerifyAndAssignPhoneCodeProfileMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly success: boolean;
    readonly user: {
      readonly email: string | null | undefined;
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly phoneNumber: {
        readonly nationalNumber: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useVerifyAndAssignPhoneCodeProfileMutation = {
  response: useVerifyAndAssignPhoneCodeProfileMutation$data;
  variables: useVerifyAndAssignPhoneCodeProfileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nationalNumber",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useVerifyAndAssignPhoneCodeProfileMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "VerifyAndAssignPhonePayload",
        "kind": "LinkedField",
        "name": "verifyAndAssignPhone",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberUser",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PhoneNumber",
                "kind": "LinkedField",
                "name": "phoneNumber",
                "plural": false,
                "selections": [
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useVerifyAndAssignPhoneCodeProfileMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "VerifyAndAssignPhonePayload",
        "kind": "LinkedField",
        "name": "verifyAndAssignPhone",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberUser",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PhoneNumber",
                "kind": "LinkedField",
                "name": "phoneNumber",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9ad77ef384d43fe66344a99f299687b6",
    "id": null,
    "metadata": {},
    "name": "useVerifyAndAssignPhoneCodeProfileMutation",
    "operationKind": "mutation",
    "text": "mutation useVerifyAndAssignPhoneCodeProfileMutation(\n  $input: VerifyAndAssignPhoneInput!\n) {\n  responsePayload: verifyAndAssignPhone(input: $input) {\n    success\n    user {\n      id\n      email\n      firstName\n      lastName\n      phoneNumber {\n        nationalNumber\n        id\n      }\n    }\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d85c7fc9f29ebb9364a83b79b808ed25";

export default node;
